import {route} from '@/router/route-utils'

const prefix = '/society';

const routes = [

    route(
        prefix + '/matches', 'society.matches', {
            components : {
                main: () => import('./views/SocietyMatchesView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Partite',
            breadcrumb: [
                {text: 'Partite', active: true},
            ],
        }
    ),

    route(
        prefix + '/matches/wizard', 'society.matches.wizard', {
            components : {
                main: () => import('./views/SocietyMatchesWizardView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Partite',
            breadcrumb: [
                {text: 'Partite', to: {name: 'society.matches'}},
                {text: 'Wizard - Nuova richiesta', active: true},
            ],
        }
    ),

    route(
        prefix +'/payment/handle', 'society.matches.handle-payment', {
            components : {
                main: () => import('./views/SocietyMatchesHandlePaymentView')
            },
            requiresAuth: true,
            layout: 'LayoutBlank',
            title: 'Handle Payment'

        }
    ),

];

export default routes
